export { ServiceTabletMobileCard } from './ServiceInsightTabletMobileCard';
